import React from 'react';
import { Hero } from './components/Hero';
import { TriggerMoment } from './components/TriggerMoment';
import { SlowLeak } from './components/SlowLeak';
import { Mechanism } from './components/Mechanism';
import { NonHormonal } from './components/NonHormonal';
import { SnakeOil } from './components/SnakeOil';
import { ProofGallery } from './components/ProofGallery';
import { Urgency } from './components/Urgency';
import { ProductReveal } from './components/ProductReveal';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FinalClose } from './components/FinalClose';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { StickyBar } from './components/StickyBar';
export function App() {
  return <div className="w-full min-h-screen bg-[#0A0A0A]" data-id="element-0">
      <Hero data-id="element-1" />
      <TriggerMoment data-id="element-2" />
      <SlowLeak data-id="element-3" />
      <Mechanism data-id="element-4" />
      <NonHormonal data-id="element-5" />
      <SnakeOil data-id="element-6" />
      <ProofGallery data-id="element-7" />
      <Urgency data-id="element-8" />
      <ProductReveal data-id="element-9" />
      <Testimonials data-id="element-10" />
      <Guarantee data-id="element-11" />
      <FinalClose data-id="element-12" />
      <FAQ data-id="element-13" />
      <Footer data-id="element-14" />
      <StickyBar data-id="element-15" />
    </div>;
}